<template>
    <div>
        <div v-if="authUserPermission['permission-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col">
                                <h3 class="mb-0">{{ tt('permission') }}</h3>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_permission')" v-on:keyup="filter"/>
                                </div>
                            </div>
                           <!--  <div class="col text-right">
                                <base-button size="sm" type="default" @click="create" v-if="authUserPermission['permission-create']">{{ tt('add_new') }}</base-button>
                            </div> -->
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('sub_menu')" :prop="tt('sub_menu')" sortable>
                                <template v-slot="{row}">
                                    {{row.sub_menu}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('type')" :prop="tt('type')" sortable>
                                <template v-slot="{row}">
                                    {{row.type}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('name')" :prop="tt('name')" sortable>
                                <template v-slot="{row}">
                                    {{row.p_name}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('guard_name')" :prop="tt('guard_name')" sortable>
                                <template v-slot="{row}">
                                    {{row.guard_name}}
                                </template>
                            </el-table-column>
                       <!--      <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                    <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true" v-if="authUserPermission['permission-update'] || authUserPermission['permission-delete']">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'edit', data:row.id}" v-if="authUserPermission['permission-update']">Edit</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}" v-if="authUserPermission['permission-delete']">Delete</el-dropdown-item>                                        
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column> -->
                        </el-table>
                        <page-loading v-else/>
                    </div>    
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>

                        <label class="form-control-label">{{ tt('sub_menu') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('sub_menu')" rules="required">
                            <el-select class="select-danger" v-model="managePermission.sub_menu_id" :placeholder="tt('choose_sub_menu')">
                                <el-option class="select-danger" :value="msm['id']" :label="msm['am_name']" :key="msm['am_name']" v-for="msm in  manageSubMenu"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('type') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('type')" :placeholder="tt('type')" v-model="managePermission.type" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('name') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('name')" :placeholder="tt('name')" v-model="managePermission.name" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('guard_name') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('guard_name')" :placeholder="tt('guard_name')" v-model="managePermission.guard_name" rules="required"></base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import managePermission from '@/services/manage/managePermission.service';
    import manageSubMenu from '@/services/setting/manageSubMenu.service';

    export default {        
        data() {
            return {              
                onLoad: true,      
                loadTimeout: null,  
                btnSave: {
                    onLoading: false
                },             
                form: {
                    add: true,
                    title: "Create New Permission",
                    show: false
                }, 
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },     
                errorMessage: null,   
                managePermission: {},
                manageSubMenu: {}
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
            this.getManageSubMenu()
        },
        methods: {
            get() { 
                let context = this;               
                Api(context, managePermission.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data = response.data.data.data.data; 
                    context.table.page  = response.data.data.data; 
                    context.onLoad = false;          
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            getManageSubMenu() {
                let context = this;               
                Api(context, manageSubMenu.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.manageSubMenu = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.manageSubMenu = [];
                    }
                })
                .call()
            },
            filter() {
                this.onLoad = true;
                this.table.page.current_page = 1;
                this.onLoad = true;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 1000);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('create_new_permission');
                this.form.show = true;
                this.managePermission = {};
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, managePermission.show(id)).onSuccess(function(response) {
                    context.managePermission = response.data.data;
                    context.form.add = false;
                    context.form.title = context.tt('update_permission');
                    context.form.show = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, managePermission.create(this.managePermission));
                } else {{
                    api = Api(context, managePermission.update(this.managePermission.id, this.managePermission));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                let context = this;
                context.confirmDialog(context.tt('confirm_delete')).then((result) => {
                    if (result.value) {
                        context.onLoad = true;
                        Api(context, managePermission.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                            context.onLoad = false;
                        }).call();
                    }
                })
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
        }   
    };
</script>
<style></style>
